<template>
  <div>
    <v-card class="pl-5 pr-5">
      <h1>Licenses</h1>
      <v-divider></v-divider>
      <div class="row">
        <div class="col">
          <div class="row">
            <div class="pl-3 col">
              <v-text-field
                id="search"
                v-model="Search"
                label="Search"
                required
                append-outer-icon="mdi-table-search"
                @click:append-outer="onSearch"
                v-on:keyup.enter="onSearch()"
              ></v-text-field>
            </div>
            <div class="pl-9 col"></div>
          </div>
          <div class="row">
            <div class="col">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                    <!--  <th class="text-left">UUID</th> -->
                      <th class="text-left">User</th>
                      <th class="text-left">Publication</th>
                      <th class="text-left">Type</th>
                      <th class="text-left">Start Date</th>
                      <th class="text-left">End Date</th>
                      <th style="width: 100px"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in list" :key="item.id">
                      <td>{{ item.user.firstName }} {{ item.user.lastName }}</td>
                      <td>{{ item.publication.Title }}</td>
                      <td>{{ item.subscriptionType }}</td>
                      <td>{{ item.startDate | formatDate}}</td>
                      <td>{{ item.endDate | formatDate}}</td>
                      <td>
                        <v-icon class="mr-2 mdi-license" @click="onStatus(item)"
                          >mdi-license</v-icon
                        >
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Pagination :paging="paging" v-on:next="onNextPage"/>
        </div>
      </div>
      <v-overlay :value="overlay">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import Notification from "@/components/Notification";
import Pagination from "@/components/Pagination";
import * as api from "@/api";
export default {
  name: "OrgLicenses",
  components: {
    Notification,
    Pagination,
  },
  created() {
    this.getLicenseByPagin();
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    resultQuery() {
      if (this.Search) {
        return this.list.filter((item) => {
          return this.Search.toLowerCase()
            .split(" ")
            .every((v) => item.email.toLowerCase().includes(v));
        });
      } else {
        return this.list;
      }
    },
  },

  methods: {
    getLicenses() {
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getAll("user-license")
          .then((response) => {
            console.log(response.data)
            this.list = response.data;
            this.paging.count = 243;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onSearch() {
      this.paging.page = 1;
      this.paging.keyword = this.Search;
      this.getLicenseByPagin();
    },
     onNextPage(page){
      this.paging.page = page;
      this.paging.keyword = this.Search
      this.getLicenseByPagin();
    },
    getLicenseByPagin() {
      let that = this;
      that.overlay = true
      this.list = [];
      console.log(this.paging)
      new Promise((resolve, reject) => {
        api
          .getByPagin("user-license",this.paging)
          .then((response) => {
            console.log(response.data)
            this.paging.count = response.data.count;
            this.list = response.data.data;
            that.overlay = false
          })
          .catch((error) => {
            reject(error);
            that.overlay = false
          });
      });
    },
    onStatus(item){
      //this.$router.push({path: '/licensesStatus', param: {licenseId: item.licenseId}})
      //this.$router.push({ path: `/licensesStatus/${item.id}` })
      window.location = `/licensesStatus/${item.id}`
    },
    onNextPage(page){
      this.paging.page = page;
      this.paging.keyword = this.Search
       this.getLicenseByPagin();
    }
  },
  data() {
    return {
      list: [],
      Search: "",
      paging: { count: 10, page: 1, size: 10,keyword:'' },
      overlay: false
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/organization/OrgLicenses.vue